import { render, staticRenderFns } from "./Popup.vue?vue&type=template&id=1a8fb1e7&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"
import style0 from "./Popup.vue?vue&type=style&index=0&id=1a8fb1e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8fb1e7",
  null
  
)

export default component.exports